<template>
    <div class="cms-dashboard">
        <div class="cms-dashboard__column">
            <cms-welcome class="cms-dashboard__panel"/>
        </div>
        <div class="cms-dashboard__column" v-if="abo">
            <div class="cms-dashboard__panel">
                <div class="cms-welcome">
                    <div class="cms-welcome__content">
                        <h1 class="cms-welcome__title"
                            v-html="$t('Mijn abonnement')"></h1>

                        <span v-html="$t('U hebt het <strong>@name</strong> abonnement', {'@name': abo})"></span>
                        <span v-if="boosters.length">{{ $t('met volgende geïnstalleerde boosters') }}:
                            <ul>
                                <li v-for="booster in boosters">{{ booster }}</li>
                            </ul>
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <router-view
            name="childview"
            @cancel="close"
        />
    </div>
</template>

<script>
export default {
    name: 'Dashboard',
    data() {
        return {
            menu: [],
            currentUrl: window.location.href,
            user: null,
            abo: null,
            boosters: [],
        }
    },
    methods: {
        close () {
            this.$router.push({name: 'dashboard'});
        }
    },
    created() {
        const userInterface = this.$userInterfaceHandler.getUserInterface();

        if (userInterface) {
            this.menu = userInterface.menu;
            this.user = userInterface.user;
        }

        let url = `${baseHref}/dashboard/ajax/getWebsiteInfo`;
        this.$get(url)
                .then((result) => {
                    this.abo = result.abo;
                    this.boosters = result.boosters;
                });
    }
}
</script>
